


































































import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { AuthViewerConfigDTO } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "AuthButtonConfig",
		components: { ButtonList }
	})
export default class AuthButtonConfig extends ParticaBaseForm<AuthViewerConfigDTO> {

	private logoutUrlconfig =
		{
			props: {
				name: "Logout Url",
				placeholder: "Enter Logout Url",
				label: "Logout Url",
			} as FormFieldProps,
			rules: { required: true, max: 250, min: 0, } as FormFieldRules
		} as IFormField;

	private logoutTextconfig =
		{
			props: {
				name: "Logout Text",
				placeholder: "Enter Logout Text",
				label: "Logout Text",
			} as FormFieldProps,
			rules: { required: true, max: 50, min: 0, } as FormFieldRules
		} as IFormField;

	private loginUrlconfig =
		{
			props: {
				name: "Login Url",
				placeholder: "Enter Login Url",
				label: "Login Url",
			} as FormFieldProps,
			rules: { required: true, max: 250, min: 0, } as FormFieldRules
		} as IFormField;

	private loginTextconfig =
		{
			props: {
				name: "Login Text",
				placeholder: "Enter Login Text",
				label: "Login Text",
			} as FormFieldProps,
			rules: { required: true, max: 50, min: 0, } as FormFieldRules
		} as IFormField;

	private signupUrlconfig =
		{
			props: {
				name: "Signup Url",
				placeholder: "Enter Signup Url",
				label: "Signup Url",
			} as FormFieldProps,
			rules: { required: true, max: 250, min: 0, } as FormFieldRules
		} as IFormField;

	private signupTextconfig =
		{
			props: {
				name: "Signup Text",
				placeholder: "Enter Signup Text",
				label: "Signup Text",
			} as FormFieldProps,
			rules: { required: true, max: 50, min: 0, } as FormFieldRules
		} as IFormField;

	private readmoreUrlconfig =
		{
			props: {
				name: "Readmore Url",
				placeholder: "Enter Readmore Url",
				label: "Readmore Url",
			} as FormFieldProps,
			rules: { required: true, max: 250, min: 0, } as FormFieldRules
		} as IFormField;

	private readmoreTextconfig =
		{
			props: {
				name: "Readmore Text",
				placeholder: "Enter Readmore Text",
				label: "Readmore Text",
			} as FormFieldProps,
			rules: { required: true, max: 50, min: 0, } as FormFieldRules
		} as IFormField;

}
